import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function ProtectedRoute() {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <div className="center-state" role="status"><span className="spinner" />Cargando sesión…</div>
  if (!user) return <Navigate to="/ingresar" replace state={{ from: location.pathname }} />
  return <Outlet />
}

export function AdminRoute() {
  const { user } = useAuth()
  if (user?.role !== 'admin') return <Navigate to="/mi-aprendizaje" replace />
  return <Outlet />
}
